import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { api } from "@/lib/api";

export default function Footer() {
  const [site, setSite] = React.useState(null);
  React.useEffect(() => { api.get("/site").then((r) => setSite(r.data)).catch(() => {}); }, []);
  const s = site || {};

  return (
    <footer className="mt-20 border-t border-[color:var(--sky-border)] bg-white">
      <div className="container-wide py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src="/skyverra-logo.png" alt="Skyverra" className="h-10 w-auto" />
            <div className="leading-tight">
              <div className="font-display font-bold text-lg tracking-tight">Skyverra</div>
              <div className="overline text-[10px]">Consulting</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-[color:var(--sky-muted)] max-w-md leading-relaxed">
            Custom CRM, LMS, web & mobile applications, and IT staffing — engineered by senior teams for
            enterprises that expect more.
          </p>
          <p className="mt-6 overline">Founder</p>
          <p className="mt-1 text-sm font-semibold">Krutika Shah</p>
        </div>

        <div>
          <p className="overline">Navigate</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link className="hover:text-[color:var(--sky-navy)]" to="/services">Services</Link></li>
            <li><Link className="hover:text-[color:var(--sky-navy)]" to="/products">Products</Link></li>
            <li><Link className="hover:text-[color:var(--sky-navy)]" to="/about">About</Link></li>
            <li><Link className="hover:text-[color:var(--sky-navy)]" to="/team">Team</Link></li>
            <li><Link className="hover:text-[color:var(--sky-navy)]" to="/careers">Careers</Link></li>
            <li><Link className="hover:text-[color:var(--sky-navy)]" to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline">Get in touch</p>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5 text-[color:var(--sky-navy)]" /><a href={`mailto:${s.company_email || 'info@skyverraconsulting.net'}`} className="hover:text-[color:var(--sky-navy)] break-all">{s.company_email || 'info@skyverraconsulting.net'}</a></li>
            <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5 text-[color:var(--sky-navy)]" /><a href={`tel:${s.company_phone || '8511236347'}`} className="hover:text-[color:var(--sky-navy)]">{s.company_phone || '8511236347'}</a></li>
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-[color:var(--sky-navy)]" /><span>{s.company_address || 'India'}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[color:var(--sky-border)]">
        <div className="container-wide py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[color:var(--sky-muted)]">
          <div>© {new Date().getFullYear()} Skyverra Consulting. All rights reserved.</div>
          <div className="font-mono-plex">Built with precision. Delivered with care.</div>
        </div>
      </div>
    </footer>
  );
}
